import { createActions } from 'redux-actions';

export const { updatePriceFormulas } = createActions('UPDATE_PRICE_FORMULAS');
